import { flexRowBetween } from '../../../../../common/styles/flex';

interface StylesObject {
  controlsWrapperStyle: { [key: string]: any };
  controlsContainerStyle: { [key: string]: any };
  iconStyle: { [key: string]: any };
}

const controlsWrapper = {
  alignItems: 'center',
  justifyContent: 'center',
  display: 'flex',
  width: '100%',
  height: '100%',
};

const controlsContainer = {
  ...flexRowBetween,
  width: '98px',
  pointerEvents: 'auto',
  height: '30px',
  opacity: 1,
};

const icon = {
  display: 'none',
  displayIcon: {
    display: 'flex',
    cursor: 'pointer',
    backdropFilter: 'blur(3px)',
  },
};

export const getExtraSmallControlsStyleObject = (showControls: boolean): StylesObject => ({
  controlsWrapperStyle: {
    ...controlsWrapper,
  },
  controlsContainerStyle: {
    ...controlsContainer,
  },
  iconStyle: [
    icon,
    showControls && icon.displayIcon,
  ],
});
